import { render, staticRenderFns } from "./incl-calendar-todos.vue?vue&type=template&id=23d37180&scoped=true"
import script from "./incl-calendar-todos.vue?vue&type=script&lang=js"
export * from "./incl-calendar-todos.vue?vue&type=script&lang=js"
import style0 from "./incl-calendar-todos.vue?vue&type=style&index=0&id=23d37180&prod&lang=scss"
import style1 from "./incl-calendar-todos.vue?vue&type=style&index=1&id=23d37180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d37180",
  null
  
)

export default component.exports